export const version = '1.2.12';
//# sourceMappingURL=version.js.map